import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Image } from 'semantic-ui-react';
import { userActions } from '../actions';
import { history } from '../helpers';
import Strings from './../common/Strings';
import './SideMenu.css';
import { isCardExpiring } from '../helpers/card';
import { failedPayment } from '../helpers/payment';

const SideMenuAction = ({ id, active, src, label, onClick, warning }) => {
  const className = `
    ${active ? 'side-menu-container active' : 'side-menu-container'}
    ${warning ? ' common-warning-circle' : ''}
  `;

  return (
    <button id={id} className={className} onClick={onClick}>
      <div className="side-menu-img-container">
        <img className="side-menu-img" src={src} alt="" />
      </div>
      <p className="side-menu-text">{label}</p>
    </button>
  );
};

SideMenuAction.propTypes = {
  id: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  src: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  warning: PropTypes.bool,
};

SideMenuAction.defaultProps = {
  warning: false,
};

class SideMenu extends React.Component {
  constructor(props) {
    super(props);

    this.unlisten = history.listen(() => {
      this.forceUpdate();
    });
  }

  componentWillUnmount() {
    if (this.unlisten) {
      this.unlisten();
    }
  }

  logOut = () => {
    const { dispatch } = this.props;
    dispatch(userActions.signOut());
  };

  render() {
    const { companyImageURL } = this.props;
    const image = companyImageURL ? (
      <img id="side-menu-company-image" src={companyImageURL} />
    ) : null;
    const nameClass = companyImageURL
      ? 'side-menu-name'
      : 'side-menu-name with-top-margin';
    return (
      <div className="side-menu-root">
        {image}
        <p id="company-name-text" className={nameClass}>
          {this.props.companyName}
        </p>
        <div className="side-menu-root-bottom-wrapper">
          <SideMenuAction
            id="history-menu-item"
            active={window.location.pathname.startsWith('/projects')}
            src="/icon/projects.svg"
            label={Strings.SIDE_MENU.projects}
            onClick={() => history.replace('/projects')}
          />
          <SideMenuAction
            id="projects-menu-item"
            active={window.location.pathname.startsWith('/directory')}
            src="/icon/directory.svg"
            label={Strings.SIDE_MENU.directory}
            onClick={() => history.replace('/directory')}
          />
          <SideMenuAction
            id="settings-menu-item"
            active={window.location.pathname.startsWith('/settings')}
            src="/icon/settings.svg"
            label={Strings.SIDE_MENU.settings}
            onClick={() => history.replace('/settings/account')}
            warning={
              (this.props.paymentCardExpiring ||
                this.props.paymentHistoryFailedPayment) &&
              !window.location.pathname.startsWith('/settings')
            }
          />
        </div>
        <div className="side-menu-line" />
        <button
          id="log-out-button"
          className="common-light-button"
          onClick={this.logOut}
        >
          {Strings.SIDE_MENU.logOut}
        </button>
        <div className="side-menu-space" />
        <Image
          id="app-logo"
          className="side-menu-bottom-img"
          src="/logo-manager.png"
        />
      </div>
    );
  }
}

SideMenu.propTypes = {
  dispatch: PropTypes.func.isRequired,
  companyName: PropTypes.string,
  companyImageURL: PropTypes.string,
  paymentCardExpiring: PropTypes.bool.isRequired,
  paymentHistoryFailedPayment: PropTypes.bool.isRequired,
};

SideMenu.defaultProps = {
  companyName: '',
  companyImageURL: '',
};

const mapStateToProps = state => ({
  companyName: state.user.companyName,
  companyImageURL: state.user.companyImageURL,
  paymentCardExpiring: isCardExpiring(
    state.paymentCards.card,
    state.upcomingInvoice.upcoming,
  ),
  paymentHistoryFailedPayment: failedPayment(state.paymentHistory.items),
});

export default connect(mapStateToProps)(SideMenu);



// WEBPACK FOOTER //
// ./src/components/SideMenu.js